interface BadgeProps {
  children: string;
  tone?: 'green' | 'gray' | 'amber' | 'orange' | 'yellow' | 'red' | 'blue';
}

const TONE_STYLES: Record<NonNullable<BadgeProps['tone']>, string> = {
  green: 'bg-emerald-100 text-emerald-700',
  gray: 'bg-slate-100 text-slate-600',
  amber: 'bg-amber-100 text-amber-700',
  orange: 'bg-orange-100 text-orange-700',
  yellow: 'bg-yellow-100 text-yellow-800',
  red: 'bg-rose-100 text-rose-700',
  blue: 'bg-sky-100 text-sky-700',
};

export function Badge({ children, tone = 'gray' }: BadgeProps): JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${TONE_STYLES[tone]}`}
    >
      {children}
    </span>
  );
}
